const refundRejectionStatus = {
  NO_BALANCE: 'NO_BALANCE',
  ACCOUNT_CLOSURE: 'ACCOUNT_CLOSURE',
  CANNOT_REFUND: 'CANNOT_REFUND',
  OTHER: 'OTHER'
};

module.exports = refundRejectionStatus;
